export enum AuthPathsEnum {
  SIGN_IN = "/sign-in",
  CREATE_SEEKER = "/create-account",
  REQUEST_RESET_PASSWORD = "/request-reset-password",
  RESET_RESET_PASSWORD_INFO = "/reset-password-info",
  RESET_PASSWORD = "/reset-password",
  CONFIRM_ACCOUNT = "/confirm",
  HOME = "/",
}
